/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import DataComponent from './main';


export const data = (context, next) => {
    context.primary = <DataComponent />;
    next();
};
